import { useState, useEffect } from "react";
import { PortalHeader } from "@/components/PortalHeader";
import { ProcessStep } from "@/components/ProcessStep";
import { PeppolIdDisplay } from "@/components/PeppolIdDisplay";
import { FailureMessage, SuccessMessage } from "@/components/SuccessMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { createParticipant, delinkParticipant, reVerifyParticipant } from "@/services/onBoardingFormServices";
import {ASP_ACCREDIATION_NUMBER,ASP_NAME,SERVICE_PROVIDER_ID,SMP_ACCESSPOINT_ID} from "@/config/env";

type StepStatus = "pending" | "loading" | "completed" | "failed";

const PeppolRegistration = () => {
  const location = useLocation();
  const dataInLocation = location.state;
  const reverifyOrDelink = '';
  const [step1Status, setStep1Status] = useState<StepStatus>("loading");
  const [step2Status, setStep2Status] = useState<StepStatus>("pending");
  const [submitted, setSubmitted] = useState(false);
  const [peppolId, setPeppolId] = useState<string>('');
  const [peppolMessage,setPeppolMessage]=useState('Peppol ID generation was unsuccessful.')
  const [onBoardingSuccess, setOnBoardingSuccess] = useState({ success: false, failure: false });
  useEffect(() => {
    const runSteps = async () => {
      // STEP 1: Generate Peppol ID
      setStep1Status("loading");
      await new Promise((res) => setTimeout(res, 2000));

      const peppolId = dataInLocation?.TIN ? `0235:${dataInLocation?.TIN}` : '';

      if (!peppolId) {
        setStep1Status("failed");
        setStep2Status("pending");
        // setShowSubmit(true);
        return;
      }
      setPeppolId(peppolId);
      const payload = {
        TIN:dataInLocation?.TIN,
        effectiveDate:dataInLocation?.effectiveDate,
        email: dataInLocation?.email,
        emarataxToken:dataInLocation?.emarataxToken,
        entityNameAr:dataInLocation?.entityNameAr,
        entityNameEn:dataInLocation?.entityNameEn,
        orgName: dataInLocation?.entityNameEn,
        legalType:dataInLocation?.legalType,
        mobile:dataInLocation?.mobile,
        address: "UAE",
        peppolId,
        countryCode: dataInLocation?.countryCode || "AE",
        vatTrn:dataInLocation?.vatTrn,
        aspAccrediationNumber: ASP_ACCREDIATION_NUMBER,
        aspName: ASP_NAME,
        serviceProviderId: SERVICE_PROVIDER_ID,
        smpAccesspointId: SMP_ACCESSPOINT_ID
      };

      // const apiHandlers = {
      //   reverify: reVerifyParticipant,
      //   delink: delinkParticipant,
      //   default: createParticipant,
      // };

      // const apiCall = apiHandlers[reverifyOrDelink] || apiHandlers.default;

      try {
        const res = await createParticipant(payload);
        setStep2Status("loading");
        if (res.data.status === "FAILED") {
          const sequence = res?.data?.sequence;
          setPeppolMessage(res?.data?.message);
          switch (sequence) {
            case '1':
              setStep1Status('failed');
              setStep2Status('pending');
              break;
            case '2':
              setStep1Status('completed');
              setStep2Status("failed");
              break;
            default:
          }
          setOnBoardingSuccess({ success: false, failure: true });
        } else {
          setStep1Status('completed');
          setStep2Status("completed");
          setOnBoardingSuccess({ success: true, failure: false });
        }
      } catch {
        setStep1Status('failed')
        setStep2Status("failed");
        setOnBoardingSuccess({ success: false, failure: true });
      } 
      finally {
      //   // setShowSubmit(true);
        setSubmitted(true);
        // setOnBoardingSuccess({ success: true, failure: false });
      }
    };


    runSteps();
  }, [dataInLocation]);
  return (
    <div className="min-h-screen bg-background">
      <PortalHeader text={reverifyOrDelink ? 'Reverifying / Delinking Request' : 'Linking Request'} description={reverifyOrDelink ? 'Please confirm details mentioned and submit your request' : ''} />

      <main className="container mx-auto px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-card rounded-xl shadow-lg border border-border p-8 space-y-8">
            <div className="text-center border-b border-border pb-6">
              <h2 className="text-2xl font-bold text-foreground">
                Peppol ID Registration
              </h2>
            </div>

            <div className="space-y-6">
              {/* Step 1 */}
              <ProcessStep
                title="Generate Peppol ID"
                description=""
                status={step1Status}
              >
                {step1Status === "completed" ? (
                  <PeppolIdDisplay peppolId={peppolId} />
                ) : step1Status === "failed" ? (
                  <p className="text-sm font-medium text-destructive">
                    {peppolMessage}
                  </p>
                ) : null}
              </ProcessStep>

              {/* Step 3 */}
              <ProcessStep
                title="Peppol ID Uploaded in FTA Registry"
                description=""
                status={step2Status}
              >
                {step2Status === "completed" ? (
                  <p className="text-sm text-success font-medium">
                    Successfully uploaded to FTA Registry.
                  </p>
                ) : step2Status === "failed" ? (
                  <p className="text-sm text-destructive font-medium">
                    Failed to upload to FTA Registry.
                  </p>
                ) : null}
              </ProcessStep>

              {/* Submit / Retry Buttons */}
              {/* {showSubmit && !submitted && (
                <div className="pt-6 flex justify-center animate-fade-in">
                  {step2Status === "completed" ? (
                    <Button
                      onClick={handleSubmit}
                      className="bg-success hover:bg-success/90 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-md transition-all hover:shadow-lg"
                    >
                      Onboarded Successfully
                    </Button>
                  ) : (
                    <Button
                      onClick={handleSubmit}
                      className="bg-destructive hover:bg-destructive/90 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-md transition-all hover:shadow-lg"
                    >
                      Onboarding Failed – Try Again
                    </Button>
                  )}
                </div>
              )} */}

              {/* Success Message */}
              {submitted && onBoardingSuccess.success && !onBoardingSuccess.failure && (
                <SuccessMessage type={reverifyOrDelink}/>
              )}

              {submitted && !onBoardingSuccess.success && onBoardingSuccess.failure && (
                <FailureMessage message={reverifyOrDelink}/>
              )}

            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PeppolRegistration;